export const createGame = {
    "length": "El equipo debe tener algun nombre!" 
};

export const roundModal = {
    "length": "Debe ingresar un valor"
}